import { useCallback, useRef } from 'react';
import { trackAnalyticsEvent } from '../lib/analytics';
import { usePaymentLanguage } from '../lib/paymentLanguage';

export const usePaymentAnalytics = (): typeof trackAnalyticsEvent => {
    const { language } = usePaymentLanguage();
    const languageRef = useRef(language);
    languageRef.current = language;
    return useCallback<typeof trackAnalyticsEvent>((eventName, properties, options) => {
        const enriched = { ...properties, form_language: languageRef.current };
        if (options) trackAnalyticsEvent(eventName, enriched, options);
        else trackAnalyticsEvent(eventName, enriched);
    }, []);
};
